import { render, staticRenderFns } from "./lp-en-primeur-purchase-campaign-II.vue?vue&type=template&id=23d50650&scoped=true"
import script from "./lp-en-primeur-purchase-campaign-II.vue?vue&type=script&lang=js"
export * from "./lp-en-primeur-purchase-campaign-II.vue?vue&type=script&lang=js"
import style0 from "./lp-en-primeur-purchase-campaign-II.vue?vue&type=style&index=0&id=23d50650&prod&scoped=true&lang=css"
import style1 from "./lp-en-primeur-purchase-campaign-II.vue?vue&type=style&index=1&id=23d50650&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d50650",
  null
  
)

export default component.exports